import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getThemeDetails } from '../redux/actions/placeActions';

export default function withThemeDetailsSubscription(WrappedComponent) {
  const mapStateToProps = ({ schema }, { themeType, id }) => ({
    data: schema[themeType].byId[id] || {},
  });

  const mapDispatchToProps = (dispatch, { link, themeType }) => ({
    getThemeDetails: () => dispatch(getThemeDetails({ link, theme: themeType })),
  });

  class ThemesSlide extends Component {
    render() {
      return <WrappedComponent data={{ ...this.props.data }} {...this.props} />;
    }

    componentDidMount() {
      const { getThemeDetails, data } = this.props;
      //make sure it is only called when there is no data in redux state to
      //minimize any redundant data calls
      //and also text is not present in initial card data which is why we know
      //that if there is no text in data, getThemeDetails() has not been called
      if (!data.text) getThemeDetails();
    }

    componentDidUpdate(prevProps) {
      const { getThemeDetails, data } = this.props;
      //To remove redundant api call, check if there was data in prevprop
      //so that this only runs once after user clicks prev or next arrow
      if (prevProps.data.id) {
        if (data.id !== prevProps.data.id) {
          if (!data.text) getThemeDetails();
        }
      }
    }
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(ThemesSlide);
}



// WEBPACK FOOTER //
// ./src/HOCs/withThemeDetailsSubscription.jsx